<template>
    <v-data-table
            v-show="!loading"
            :headers="headers"
            :items="records"
            :server-items-length="records.length"
            :loading="loading"
            must-sort
            :multi-sort="false"
            hide-default-footer
            fixed-header
            height="500"
            dense
            :item-class="rowColor"
            @click:row="itemClick"
            class="custom-table"
    >
        <template v-slot:[`item.workerCode`]="{ item }">
            <v-chip dark label color="teal" small class="ma-1">
                {{ item.workerCode }}
            </v-chip>
        </template>
    </v-data-table>
  <!--  :class="`elevation-${tableElevation}`"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
        :item-class="rowClass"
        @click:row="itemClick"
        @dblclick:row="view" -->

  <!--<v-simple-table dense fixed-header height="500">
      <template v-slot:default>
          <thead>
          <tr>
              <th class="text-left">Code</th>
              <th class="text-left">Nom & Prénom</th>
              <th
                  v-for="(header, index) in headers"
                  :key="`th-${index}`"
                  class="text-left"
              >
                  <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                              {{ header.value }}
                          </span>
                      </template>
                      <span>{{ header.text }}</span>
                  </v-tooltip>
              </th>
          </tr>
          </thead>
          <tbody>
          <tr
              @click="itemClick(record)"
              v-for="(record, index) in records.sort((a, b) => a.workerCode.localeCompare(b.workerCode))"
              :key="`tr-${index}`"
          >
              <td class="text-left">
                  <v-chip dark label color="teal" small class="ma-1">
                      {{ record.workerCode }}
                  </v-chip>
              </td>
              <td class="text-left">{{ record.workerName }}</td>
              <td
                  v-for="(header, index) in headers"
                  :key="`td-${index}`"
                  class="text-left"
              >
                  {{ record[header.value] }}
              </td>
          </tr>
          </tbody>
      </template>
  </v-simple-table>-->
</template>

<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    name: "PaySectionImportDisplay",
    props: {
        paySectionImports: Array,
        loading: Boolean,
    },
    setup(props) {
        const {selectedOne, itemColor} = useSharedData();
        const headers = ref([]);
        const records = ref([]);

        function addHeadHeader() {
            headers.value = [
                {
                    text: "Matricuel",
                    align: "center",
                    sortable: true,
                    value: "workerCode",
                    order: -20,
                    width: "0%",
                },
                {
                    text: "Nom & prénom",
                    align: "center",
                    sortable: true,
                    value: "workerName",
                    order: -19,
                    width: "250px",
                },
            ]
        }

        function addHeader(detail) {
            if (!headers.value.some((header) => header.value === detail.paySectionCode)) {
                headers.value.push({
                    text: detail.paySectionCode,
                    align: "center",
                    sortable: false,
                    value: detail.paySectionCode,
                    order: detail.order,
                    width: "0%",
                });
            }
        }

        function build() {
            records.value = [];
            headers.value = [];
            addHeadHeader();
            props.paySectionImports.forEach((element) => {
                let record = {
                    workerCode: element.workerCode,
                    workerName: element.workerName,
                };
                element.values.forEach((detail) => {
                    record[detail.paySectionCode] = detail.value.toFixed(2);
                    addHeader(detail);
                });
                records.value.push(record);
            });
        }

        const selectedCode = ref(null);

        function itemClick(record) {
            selectedCode.value = record;
        }

        function rowColor(item) {
            if (item.workerCode === selectedOne.value.workerCode) {
                return itemColor.value;
            }
        }

        watch(() => props.paySectionImports, () => {
            build();
        }, {immediate: true, deep: true});

        return {
            records,
            headers,
            selectedCode,
            itemClick,
            rowColor
        }
    }
}
</script>

<style lang="css">
.custom-table {
    white-space: nowrap;
}

.custom-table td, .custom-table th {
    white-space: nowrap;
    overflow: hidden;
    border: 1px solid #e0e0e0;
}
</style>